import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { HeroSection } from '@trashlab/sitesapp/src/templates/default/components/shared/hero-section';
import { CtaSection } from '@trashlab/sitesapp/src/templates/default/components/shared/cta-section';
import { useTenantContext } from '@trashlab/sitesapp/src/contexts/use-tenant-context';
import ContactCards from '@/templates/default/components/request-service/contact-cards';
import { RequestServiceForm } from '@/templates/default/components/request-service/request-service-form';
import { useVariantValue } from '@trashlab/sitesapp/src/lib/utils/get-variant-value';

const ContactUsPage = () => {
  const { website } = useTenantContext();

  const contactUsHeroSubtitle = useVariantValue(
    'CONTACT_US_HERO_SUBTITLE',
    `Get in touch with ${
      website?.organization?.name ?? 'us'
    } today to transform your waste management experience with our prompt, affordable, and reliable services.`,
  );

  return (
    <>
      <HeroSection title="Set up service" content={contactUsHeroSubtitle} />
      <ContactCards />
      <RequestServiceForm withBackground />
      <CtaSection secondary />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/contact-us',
  component: ContactUsPage,
});
